import { useEffect, useState } from 'react';
import { ShirtCustomizer, type ComprarPayload } from './shirt/ShirtCustomizer';
import { CheckoutView, type Customizacao } from './checkout/CheckoutView';
import { fetchProdutos, type Produto } from './lib/api';

type Passo = 'camisa' | 'checkout';

export function App() {
  const [passo, setPasso] = useState<Passo>('camisa');
  const [customizacao, setCustomizacao] = useState<Customizacao | null>(null);
  const [camisa, setCamisa] = useState<Produto | null>(null);
  const [erroProduto, setErroProduto] = useState('');

  useEffect(() => {
    fetchProdutos()
      .then((ps) => {
        const c = ps.find((p) => p.sku === 'CAMISA-UV') ?? ps.find((p) => p.tipo === 'PHYSICAL');
        if (c) setCamisa(c);
        else setErroProduto('Produto da camisa não encontrado.');
      })
      .catch(() => setErroProduto('Não consegui carregar o produto (checkout indisponível).'));
  }, []);

  function comprar(p: ComprarPayload) {
    setCustomizacao(p);
    setPasso('checkout');
    window.scrollTo({ top: 0 });
  }

  if (passo === 'checkout' && customizacao && camisa) {
    return (
      <main>
        <CheckoutView produto={camisa} customizacao={customizacao} onVoltar={() => setPasso('camisa')} />
      </main>
    );
  }

  return (
    <main>
      {/* só habilita "Comprar" quando o produto carregou (checkout disponível) */}
      <ShirtCustomizer onComprar={camisa ? comprar : undefined} />
      {erroProduto && (
        <p className="mx-auto max-w-5xl px-4 pb-8 text-center text-xs text-amber-100/50">
          {erroProduto} Você ainda pode personalizar e baixar a prévia.
        </p>
      )}
    </main>
  );
}
